import config from '../../config';

const VERSION_CHECKER_PATH = `${config.basePath}/version.txt`;

export const getVersion = async () => {
  const response = await fetch(VERSION_CHECKER_PATH, {
    headers: {
      'cache-Control': 'no-cache',
      pragma: 'no-cache',
    },
  });

  return response.text();
};
